import { useTranslation } from 'react-i18next';
import { SubscriptionTypesEnum } from '@thinknet-gmbh/platform-common';
import { PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';

import { useGetCurrentSubscription } from 'src/hooks/subscriptions/get-current-subscription.hook';

import { PaymentInfoViewWrapper, InfoBlock } from './payment-info-view.styles';
import { expireDateFormatter, formatPaymentPrice } from './payment-info-view.helpers';

const PaymentInfoView = () => {
  const { t } = useTranslation(['common', 'products']);
  const { subscription } = useGetCurrentSubscription();
  const { paymentMethod, softwarePlan, recurringType, totalPrice } = subscription;

  if (!paymentMethod || !softwarePlan) {
    return null;
  }

  return (
    <PaymentInfoViewWrapper>
      <div>
        <InfoBlock>
          <Typography weight="bold">{t('common:labels.softwareModule')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {softwarePlan.refModuleName}
          </Typography>
        </InfoBlock>
        <InfoBlock>
          <Typography weight="bold">{t('common:labels.softwarePlan')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {softwarePlan.name}
          </Typography>
        </InfoBlock>
        <InfoBlock>
          <Typography weight="bold">{t('common:labels.price')}:</Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {formatPaymentPrice(totalPrice, softwarePlan.currency, recurringType)}
          </Typography>
        </InfoBlock>
        {subscription.subscriptionType === SubscriptionTypesEnum.PAID && (
          <InfoBlock>
            <Typography weight="bold">{t('common:labels.paidEmployeesAmount')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {`${subscription.maxCustomerRange} (${t('common:labels.used')}: ${
                subscription.usedEmployeesPlacesCount
              })`}
            </Typography>
          </InfoBlock>
        )}
      </div>
      <div>
        <InfoBlock>
          <Typography weight="bold">
            {paymentMethod.cardNumber ? `${t('products:labels.cardNumber')}:` : 'IBAN:'}
          </Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {`**** **** **** ${paymentMethod.cardNumber || paymentMethod.ibanNumber}`}
          </Typography>
        </InfoBlock>
        {paymentMethod.exp_year && paymentMethod.exp_month && (
          <InfoBlock>
            <Typography weight="bold">{t('products:labels.expiryDate')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {expireDateFormatter(paymentMethod.exp_year, paymentMethod.exp_month)}
            </Typography>
          </InfoBlock>
        )}
        {paymentMethod.email ? (
          <InfoBlock>
            <Typography weight="bold">{t('common:labels.email')}:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
              {paymentMethod.email}
            </Typography>
          </InfoBlock>
        ) : (
          <InfoBlock>
            <Typography weight="bold">CVC/CVV:</Typography>
            <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>***</Typography>
          </InfoBlock>
        )}
        <InfoBlock>
          <Typography weight="bold">
            {paymentMethod.cardNumber
              ? t('products:labels.cardholderName')
              : t('products:labels.accountHolderName')}
            :
          </Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {paymentMethod.accountHolderName}
          </Typography>
        </InfoBlock>
      </div>
    </PaymentInfoViewWrapper>
  );
};

export default PaymentInfoView;
